import fetchWithRefresh from './fetchWithRefresh';
import { PATIENT_DIR, PATIENT_DIR_TRINITY } from './constants';
import { Draft } from './fetchPxDraft';
import { VISIT_TYPE } from './fetchAllVisitsForPatient';

export interface PatientDirResponse {
    status: string;
    data?: Patient[] | null;
    version?: number;
}
export interface Patient {
    id: string;
    uuid?: string;
    poid?: string;
    payments?: {
        dues: number;
    };
    profile: Profile;
    formData?: PatientFormData[];
    created_at: string;
    updated_at: string;
    docids?: string[];
    visits?: VisitsEntity[] | null;
    followup?: string | null;
    last_visit?: string | null;
    archived?: boolean;
    link?: string[];
    abha?: {
        id?: string;
        records?: number;
    };
    abhaV2?: {
        id?: string;
        records?: number;
        cId?: string;
        status?: string;
    }[];
    referredBy?: string;
    refer_id?: string;
    relations?: Relation[];
}

export interface PatientFormData {
    label: string;
    type: 'number' | 'string' | 'select';
    key: string;
    value: string | number;
}
export interface Profile {
    personal: Personal;
}
export interface Personal {
    name: string;
    age: Age;
    phone?: Phone;
    gender?: string | null;
    bloodgroup?: string | null;
    onApp?: boolean;
    'health-ids'?: string[];
}
export interface Age {
    dob: string;
}
export interface Phone {
    c?: string;
    n?: string;
}
export interface VisitsEntity {
    vid: string;
    visit_date: string;
    url: string;
    pxid: string;
    name: string;
    clinicid: string;
    status: string;
    draft?: Draft;
    type?: VISIT_TYPE;
    docid: string;
    doc_name?: string;
}

export interface Relation {
    pid: string;
    rid: string;
}

export default (docIds: string[], pid?: string, from?: string, pageNo?: string, pageSize?: string): Promise<PatientDirResponse> =>
    fetchWithRefresh(PATIENT_DIR_TRINITY(docIds, pid, from, pageNo, pageSize)).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw Error('Error fetching Patient dir');
        }
    });
